import React from 'react';

// The values the question bank's `language` column allows. The API refuses
// anything else and treats a missing value as 'en'.
export const QUIZ_LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'हिन्दी (Hindi)' }
];

export const DEFAULT_QUIZ_LANGUAGE = 'en';

interface LanguageSelectionProps {
  selectedLanguage: string;
  onLanguageChange: (language: string) => void;
}

const LanguageSelection: React.FC<LanguageSelectionProps> = ({
  selectedLanguage,
  onLanguageChange
}) => {
  return (
    <div className="mb-4">
      <label className="form-label fw-semibold">
        <i className="fas fa-language me-2 text-primary"></i>
        Question Language
      </label>
      <div className="row g-2">
        {QUIZ_LANGUAGE_OPTIONS.map(language => (
          <div key={language.value} className="col-md-4">
            <input
              type="radio"
              className="btn-check"
              name="quiz-language"
              id={`quiz-language-${language.value}`}
              checked={selectedLanguage === language.value}
              onChange={() => onLanguageChange(language.value)}
            />
            <label
              className="btn btn-outline-secondary w-100 py-2"
              htmlFor={`quiz-language-${language.value}`}
              style={{ borderRadius: '12px' }}
            >
              {language.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelection;
